import React from 'react'


class NotFoundPage extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({event: 'page_not_found', path: location.pathname})
    }
  }
  
  render() {
    return (
      <div style={{height: 'calc(100vh - 64px)', minHeight: '100%', padding: '1.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <h1 style={{minWidth: '100%', maxWidth: '100%', fontSize: '20vw', lineHeight: '20vw', textAlign: 'center', margin: '0'}}>404</h1>
        <h1 style={{minWidth: '100%', maxWidth: '100%', fontSize: '6vw', lineHeight: '4vw', textAlign: 'center', textTransform: 'uppercase', margin: '0'}}>Page not found</h1>
        <h5 style={{minWidth: '100%', maxWidth: '100%', fontSize: '3vw', lineHeight: '3vw', textAlign: 'center', marginTop: '6vw'}}>Oops! We can't seem to find the page you're looking for...</h5>
      </div>
    )
  }
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js